import { render } from "./CosulMeu.vue?vue&type=template&id=a52aa3fa"
import script from "./CosulMeu.vue?vue&type=script&lang=js"
export * from "./CosulMeu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__